/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import FormDateTimeField, {
  FormDateTimeFieldProps
} from '../../../../client/js/components/form/fields/FormDatetimeField'

function AvailableAtField (props: FormDateTimeFieldProps) {
  const { name = 'availableAt', ...others } = props
  const intl = useIntl()
  return (
    <FormDateTimeField
      label={intl.formatMessage({
        id: 'available_at',
        defaultMessage: 'Disponible le'
      })}
      name={name}
      {...others}
    />
  )
}

export default AvailableAtField
